//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "verification",
  data(){
    return {
      type:'phone',
      isCooldown: false,
      canSubmit: false,
      canSubmit2:false,
      cdTime:60,
      form:{
        phone:'',
        code:'',
        password:'',
        cpassword:''
      }
    }
  },
  created() {
    // if(this.$route.params.type!='phone'&&this.$route.params.type!='password'){
    //   this.$router.replace('/verification/phone')
    // }else{
    //   this.type=this.$route.params.type;
    // }
  },
  methods:{
    sendEms(){
      if(this.form.phone&&this.form.phone!=''){
        if(!(/^1[3456789]\d{9}$/.test(this.form.phone))){
          alert("手机号码有误");
          return false;
        }
      }else{
        alert('请输入手机号码');
        return false;
      }
      this.axios.post('xcx/User/sendcode',{phone:this.form.phone,type:2,user_key:this.$store.state.tempat}).then((res)=>{
        this.isCooldown=true;
        var timer=setInterval(()=>{
          this.cdTime--;
          if(this.cdTime<=0){
            this.isCooldown=false;
            this.cdTime=60
            clearInterval(timer);
          }
        },1000)
      })
    },
    changePwd(){
      let _this=this;
      this.axios.post('/xcx/User/resetpass',{...this.form,user_key:this.$store.state.tempat}).then(res=>{
        this.$vux.alert.show({
          title:'提示',
          content:'密码修改成功',
          onHide(){
            _this.$router.replace({name:'login'});
          }
        })
        
      })
    }
  },
  mounted() {
      if(this.type=="phone"){
        document.title='手机验证';
      }else{
        document.title='密码设置'
      }
  },
  watch:{
    'form':{
      handler:function(n,o){
        // console.log(n,o);
        if(!(/^1[3456789]\d{9}$/.test(n.phone))||n.code==''){
          this.canSubmit=false;
        }else{
          this.canSubmit=true;
        }

        if(n.password!=''&&(n.password==n.cpassword)){
          this.canSubmit2=true;
        }else {
          this.canSubmit2=false;
        }
      },
      deep:true
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/verification/verification.vue